import Alpine from 'alpinejs';

import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';

import cmsStore from './stores/cms';
import treeStore from './stores/tree';

window.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.plugin(intersect);

Alpine.store('cms', cmsStore);
Alpine.store('tree', treeStore);

Alpine.start();
